module.exports = __webpack_public_path__ + "icon_blue.6e30965f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Loading/imgs/icon_blue.png
// module id = 6atW
// module chunks = 0